import Service from 'core/service'
import type { IUserParameters } from 'interfaces'

export class UserService extends Service {
  checkEmailIsUsed(email: string): Promise<{ used: boolean }> {
    return this.post('/users/is-used', { email })
  }
  getMe(): Promise<UserModel> {
    return this.get('/users/me')
  }
  getListUsers(params: object): Promise<UserModel[]> {
    return this.get('/users', params)
  }
  createUser(params: object): Promise<UserModel> {
    return this.post('/users', params)
  }
  updateUser(params: IUserParameters): Promise<UserModel> {
    return this.put(`/users/${params.id}`, params)
  }
  deleteUser(params: IUserParameters): Promise<void | null> {
    return this.delete(`/users/${params.id}/${params.divisionId}`)
  }
  changePassword(params: object): Promise<object> {
    return this.post('/users/change-password', params)
  }
  createEndUser(params: object): Promise<UserModel> {
    return this.post('/applications/users', params)
  }
  getListEndUser(params: object): Promise<UserModel[]> {
    return this.get('/applications/users', params)
  }
  updateEndUser(params: IUserParameters): Promise<UserModel> {
    return this.put(`/applications/users/${params.id}/${params.divisionId}`, params)
  }
  deleteEndUser(params: IUserParameters): Promise<UserModel> {
    return this.delete(`/applications/users/${params.id}/${params.divisionId}`)
  }
}
